import { apiFetch } from '../../../lib/api';

const PREFIX = '/api/v1';

// --- Roles ---

export const getRoles = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.skip !== undefined) query.append('skip', params.skip);
  if (params.limit !== undefined) query.append('limit', params.limit);
  if (params.is_active !== undefined) query.append('is_active', params.is_active);
  if (params.q) query.append('q', params.q);

  const qs = query.toString();
  return apiFetch(`${PREFIX}/roles${qs ? `?${qs}` : ''}`);
};

export const getRoleById = async (id) => {
  return apiFetch(`${PREFIX}/roles/${id}`);
};

export const createRole = async (data) => {
  return apiFetch(`${PREFIX}/roles`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

export const updateRole = async (id, data) => {
  return apiFetch(`${PREFIX}/roles/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
};

export const deleteRole = async (id) => {
  return apiFetch(`${PREFIX}/roles/${id}`, {
    method: 'DELETE'
  });
};

// --- Permissions ---

export const getPermissions = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.skip !== undefined) query.append('skip', params.skip);
  if (params.limit !== undefined) query.append('limit', params.limit);
  if (params.q) query.append('q', params.q);

  const qs = query.toString();
  return apiFetch(`${PREFIX}/permissions${qs ? `?${qs}` : ''}`);
};

export const getPermissionById = async (id) => {
  return apiFetch(`${PREFIX}/permissions/${id}`);
};

export const createPermission = async (data) => {
  return apiFetch(`${PREFIX}/permissions`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

export const updatePermission = async (id, data) => {
  return apiFetch(`${PREFIX}/permissions/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
};

export const deletePermission = async (id) => {
  return apiFetch(`${PREFIX}/permissions/${id}`, {
    method: 'DELETE'
  });
};

// --- Role <-> Permission Mapping ---

export const getRolePermissions = async (roleId) => {
  return apiFetch(`${PREFIX}/roles/${roleId}/permissions`);
};

export const assignRolePermissions = async (roleId, permissionIds) => {
  return apiFetch(`${PREFIX}/roles/${roleId}/permissions`, {
    method: 'POST',
    body: JSON.stringify({ permission_ids: permissionIds })
  });
};

export const removeRolePermission = async (roleId, permissionId) => {
  return apiFetch(`${PREFIX}/roles/${roleId}/permissions/${permissionId}`, {
    method: 'DELETE'
  });
};

// --- User <-> Role Assignment ---

export const getUserRoles = async (userId) => {
  return apiFetch(`${PREFIX}/users/${userId}/roles`);
};

export const assignUserRoles = async (userId, roleIds) => {
  return apiFetch(`${PREFIX}/users/${userId}/roles`, {
    method: 'POST',
    body: JSON.stringify({ role_ids: roleIds })
  });
};

export const removeUserRole = async (userId, roleId) => {
  return apiFetch(`${PREFIX}/users/${userId}/roles/${roleId}`, {
    method: 'DELETE'
  });
};

export const getUserPermissions = async (userId) => {
  return apiFetch(`${PREFIX}/users/${userId}/permissions`);
};
